import { SGeneralForms } from 'shj-components'
import { useEffect, useRef, useState } from 'react'
import { getSpecialCodesList, SubItemManagementSaveCache } from '@/services/product.ts'
import { trimStr } from '@/utils/data.ts'
import { Select } from 'antd'
import { isEmpty } from 'lodash-es'

const StepBaseInfo = props => {
  const { editRef, state, setState } = props
  const ref = useRef()
  const [specialCodeList, setSpecialCodeList] = useState([])
  const onFormRef = () => {
    const { onFormRef } = ref.current || {}
    return onFormRef?.()
  }

  useEffect(() => {
    if (!isEmpty(state)) {
      onFormRef()?.setFieldsValue(state)
    }
  }, [state])

  const onFinish = (): Promise<any> => {
    return new Promise((resolve, reject) => {
      onFormRef()
        ?.validateFields()
        .then(values => {
          setState({
            ...state,
            ...values,
          })
          resolve(values)
        })
        .catch(error => {
          reject(error)
        })
    })
  }
  const getOptions = async () => {
    let specialCodeList: any = await getSpecialCodesList({
      data: {},
    })
    specialCodeList = specialCodeList.map(item => ({ label: item.showName, value: item.code }))
    setSpecialCodeList(specialCodeList)
    return Promise.resolve({ specialCodeList })
  }
  if (editRef) editRef.onFinish = onFinish

  return (
    <>
      <SGeneralForms
        ref={ref}
        layout={'vertical'}
        httpOptionsFn={getOptions}
        configs={[
          {
            formItem: [
              { name: 'id', hidden: true },
              {
                spanCol: 24,
                label: '子项名称',
                name: 'itemName',
                required: true,
                rules: [{ required: true, message: '子项名称不能为空' }],
                comConfig: {
                  style: { width: 460 },
                  showCount: true,
                  maxLength: 15,
                  onChange: e => onFormRef()?.setFieldValue('itemName', trimStr(e.target.value)),
                },
              },
              {
                spanCol: 24,
                label: '备注',
                name: 'remarks',
                comConfig: {
                  style: { width: 460 },
                  showCount: true,
                  maxLength: 100,
                },
              },
              {
                name: 'specialCode',
                label: '特项代码',
                spanCol: 24,
                children: (
                  <Select
                    allowClear
                    placeholder="请选择"
                    style={{ width: 460 }}
                    options={specialCodeList}
                    showSearch
                    filterOption={(input, option) =>
                      (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                    }
                    onChange={e => onFormRef()?.setFieldValue('specialCode', e)}
                  />
                ),
              },
            ],
          },
        ]}
      />
    </>
  )
}

export default StepBaseInfo
